module.exports = __webpack_public_path__ + "static/media/20ECE30.f6473fe0.jpg";